import { validationRules } from './constants'

const formValidation = {
  firstName: {
    required: 'Please enter first name.',
    pattern: {
      value: /^[^\s].*/,
      message: 'Cannot start with a space.'
    },
    minLength: {
      value: 2,
      message: 'Minimum length must be 2.'
    }
  },
  companyName: {
    required: 'Please enter company name.',
    pattern: {
      value: /^[^\s].*/,
      message: 'Cannot start with a space.'
    },
    minLength: {
      value: 2,
      message: 'Minimum length must be 2.'
    }
  },
  lastName: {
    required: 'Please enter last name.',
    pattern: {
      value: /^[^\s].*/,
      message: 'Cannot start with a space.'
    },
    minLength: {
      value: 2,
      message: 'Minimum length must be 2.'
    }
  },
  email: {
    required: 'Please enter email ID.',
    pattern: {
      value: validationRules.email,
      message: 'Please enter valid email ID as: example@domain.com.'
    }
  },
  subscriptionName: {
    required: 'Please enter subscription name.',
    pattern: {
      value: /^[a-zA-Z]+$/,
      message: 'Invalid subscription name.'
    },
    minLength: {
      value: 2,
      message: 'Minimum length must be 2.'
    }
  },
  subAdminName: {
    required: 'Please enter subadmin name.',
    pattern: {
      value: /^[^\s].*/,
      message: 'Cannot start with a space.'
    },
    minLength: {
      value: 2,
      message: 'Minimum length must be 2.'
    }
  },
  name: {
    required: 'Please enter company name.',
    pattern: {
      value: /^[^\s].*/,
      message: 'Cannot start with a space.'
    },
    minLength: {
      value: 2,
      message: 'Minimum length must be 2.'
    }
  },
  categoryName: {
    required: 'Please enter category name.',
    pattern: {
      value: /^[^\s].*/,
      message: 'Cannot start with a space.'
    },
    minLength: {
      value: 2,
      message: 'Minimum length must be 2.'
    }
  },
  mobile: {
    required: 'Please enter mobile number.',
    minLength: {
      value: 7,
      message: 'Minimum length should be 7 digits.'
    },
    min: {
      value: 0,
      message: 'Minimum value must is 0.'
    },
    maxLength: {
      value: 15,
      message: 'Maximum length should be 15 digits.'
    }
  },
  alternateEmail: {
    required: 'Please enter alternate email ID.',
    pattern: {
      value: validationRules.email,
      message: 'Please enter valid alternate email ID as: example@domain.com.'
    }
  },
  description: {
    required: 'Please enter description.',
    minLength: {
      value: 10,
      message: 'Description should contains at least 10 characters.'
    },
    maxLength: {
      value: 300,
      message: 'Description should not exceed 300 characters.'
    }
  },
  title: {
    required: 'Please enter title.',
    minLength: {
      value: 2,
      message: 'Title should contains at least 2 characters.'
    },
    maxLength: {
      value: 100,
      message: 'Title should not exceed 100 characters.'
    }
  },
  HRName: {
    required: 'Please enter HR name.',
    pattern: {
      value: validationRules.characters,
      message: validationRules.charactersMessage
    },
    minLength: {
      value: 2,
      message: 'Minimum length must be 2.'
    }
  },

  address: {
    required: 'Please enter address.',
    minLength: {
      value: 10,
      message: 'Address should contain at least 10 characters.'
    },
    maxLength: {
      value: 100,
      message: 'Description should not exceed 100 characters.'
    }
  },
  accountantName: {
    required: 'Please enter accountant name.',
    pattern: {
      value: validationRules.characters,
      message: validationRules.charactersMessage
    },
    minLength: {
      value: 2,
      message: 'Minimum length must be 2.'
    }
  },
  jobTitle: {
    required: 'Please enter job title.',
    minLength: {
      value: 2,
      message: 'Minimum length must be 2.'
    }
  },
  jobDescription: {
    required: 'Please enter job description.',
    validate: value => {
      const words = value.trim().split(' ')
      if (words.length <= 9) {
        return 'Job description should contains at least 10 words.'
      } else if (words.length > 499) {
        return 'Job description should not exceed 500 words.'
      }
      return null
    }
  },
  terminationCondition: {
    required: 'Please enter termination description.',
    validate: value => {
      const words = value.trim().split(' ')
      if (words.length <= 9) {
        return 'Termination condition should contains at least 10 words.'
      } else if (words.length > 499) {
        return 'Termination condition should not exceed 500 words.'
      }
      return null
    }
  },

  departmentName: {
    required: 'Please enter department name.',
    pattern: {
      value: validationRules.characters,
      message: validationRules.charactersMessage
    },
    minLength: {
      value: 2,
      message: 'Minimum length must be 2.'
    }
  },
  skillName: {
    required: 'Please enter skill name.',
    pattern: {
      value: validationRules.characters,
      message: validationRules.charactersMessage
    },
    minLength: {
      value: 2,
      message: 'Minimum length must be 2.'
    }
  },
  supportDescription: {
    required: 'Please enter description.',
    minLength: {
      value: 10,
      message: 'Description should contains at least 10 characters.'
    },
    maxLength: {
      value: 500,
      message: 'Description should not exceed 500 characters.'
    }
  },
  taskName: {
    required: 'Please enter task name.',
    pattern: {
      value: validationRules.characters,
      message: validationRules.charactersMessage
    },
    minLength: {
      value: 2,
      message: 'Minimum length must be 2.'
    }
  },
  employeeID: {
    required: 'Please enter employee ID.',
    minLength: {
      value: 1,
      message: 'Minimum length must be 1.'
    }
  },
  taskDescription: {
    required: 'Please enter task description.',
    minLength: {
      value: 10,
      message: 'Description should contains at least 10 characters.'
    },
    maxLength: {
      value: 500,
      message: 'Description should not exceed 500 characters.'
    }
  },
  taskAddress: {
    required: 'Please enter task address.',
    minLength: {
      value: 10,
      message: 'Task address should contains at least 10 characters.'
    },
    maxLength: {
      value: 500,
      message: 'Task address should not exceed 500 characters.'
    }
  }
}

export default formValidation
